export default "__VITE_ASSET__D67ng9SF__"